/** Staff roles. Students are records, never accounts, so they appear nowhere here. */
export const ROLES = ['super_admin', 'org_admin', 'teacher'] as const;
export type Role = (typeof ROLES)[number];

/** What a teacher can record for a student in a single period. */
export const ATTENDANCE_STATUSES = ['present', 'absent', 'late', 'excused'] as const;
export type AttendanceStatus = (typeof ATTENDANCE_STATUSES)[number];

/** A class meeting either happened or was called off. */
export const SESSION_STATUSES = ['held', 'cancelled'] as const;
export type SessionStatus = (typeof SESSION_STATUSES)[number];

/**
 * Attendance-rate semantics, defined once and referenced by both the SQL
 * reporting queries and the TypeScript reference implementation so the two
 * cannot drift apart.
 *
 *   rate = (present + late) / (present + late + absent)
 *
 * Excused absences are dropped from the denominator entirely: the student was
 * legitimately not expected, so the absence neither helps nor hurts the number.
 */
export const ATTENDED_STATUSES = ['present', 'late'] as const satisfies readonly AttendanceStatus[];
export const MISSED_STATUSES = ['absent'] as const satisfies readonly AttendanceStatus[];
export const RATE_EXCLUDED_STATUSES = ['excused'] as const satisfies readonly AttendanceStatus[];

/** 0 = Sunday, matching both JS `Date#getDay` and Postgres `EXTRACT(DOW)`. */
export const WEEKDAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const;
